module.exports = __webpack_public_path__ + "static/img/bookmark.46c93d93.svg";